import { IProduktdefinition } from "./IProduktdefinition";
export class MassediteraProduktdefinitionDto {
    grundProduktdefinition: IProduktdefinition;
    ovrigaProduktdefinitioner: IProduktdefinition[];

    constructor(grundProduktdefinition: IProduktdefinition, ovrigaProduktdefinitioner: IProduktdefinition[]) {
        this.grundProduktdefinition = grundProduktdefinition;
        this.ovrigaProduktdefinitioner = ovrigaProduktdefinitioner;
    }
}
